const config = {
  development: {
    REGION: 'ap-southeast-1',
    BUCKET: 'kambria-static',
    URL: 'https://s3-ap-southeast-1.amazonaws.com/',
  },
  staging: {
    REGION: 'ap-southeast-1',
    BUCKET: 'kambria-static',
    URL: 'https://s3-ap-southeast-1.amazonaws.com/',
  },
  production: {
    REGION: 'ap-southeast-1',
    BUCKET: 'static.kambria.io',
    URL: 'https://',
  },
};

export default config;
